import React from 'react';
import Spinner from 'react-bootstrap/Spinner';

function BtnSpinner() {
  return <Spinner animation="border" />;
}

export default BtnSpinner;